export default "__VITE_ASSET__b747d79b__"